import React, { useMemo } from 'react';
import { createPortal } from 'react-dom';
import moment from 'moment';
import EcoEmail, { EmailFieldsType } from 'eco-design/elements/eco-email';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import { useGlobal } from '@/utils/useGlobal';

interface Props {
    onClose: () => void;
    open: boolean;
}

const contactListIds = {
    us: '986635575',
    ca: '2097466008',
};

const Dialog: React.FC<Props> = ({ onClose, open }) => {
    const { t } = useLang('rapidpro.C_dialog');
    const { locale } = getLocal();
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();

    const fields = useMemo(() => {
        const date = moment(systemTime).format('YYYY-MM-DD') as any;
        const NA_Fields: EmailFieldsType[] = [
            { type: 'single', id: '31', value: 1, overwrite: false },
            { type: 'multiple', id: '11150', value: [14], overwrite: false },
            { type: 'text', id: '12637', value: date, overwrite: false },
        ];
        switch (locale) {
            case 'us':
                return [{ type: 'single', id: '4423', value: 1, overwrite: true }, ...NA_Fields];
            case 'ca':
                return [{ type: 'single', id: '4424', value: 1, overwrite: true }, ...NA_Fields];
            default:
                return [{ type: 'single', id: '4423', value: 1, overwrite: true }, ...NA_Fields];
        }
    }, [locale, systemTime]);

    // 邮件
    const termsHtml = useMemo(() => {
        switch (locale) {
            case 'us':
            case 'ca':
                return `I agree to EcoFlow's <a href="https://account.ecoflow.com/agreement/en-${locale}/PrivacyPolicy.html" target="_blank">Privacy Policy</a> and <a href="https://${locale}.ecoflow.com/pages/terms-of-use" target="_blank">Terms of Use</a>.`;
            default:
                return undefined;
        }
    }, [locale]);

    if (!open) return null;
    return createPortal(
        <div className={`${style.comp} GtmModuleData-section`} data-section-id={style.comp} data-section-title={t('title')}>
            <div className="mask"></div>
            <div className="body">
                <div className="close" onClick={onClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="10" cy="10" r="10" fill="white" fillOpacity="0.4" />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.76758 9.82812L6.46918 12.1265C6.17629 12.4194 6.17629 12.8943 6.46918 13.1872C6.76207 13.4801 7.23695 13.4801 7.52984 13.1872L9.82824 10.8888L12.1266 13.1872C12.4195 13.4801 12.8944 13.4801 13.1873 13.1872C13.4802 12.8943 13.4802 12.4194 13.1873 12.1265L10.8889 9.82812L13.1867 7.53033C13.4796 7.23744 13.4796 6.76256 13.1867 6.46967C12.8938 6.17678 12.4189 6.17678 12.126 6.46967L9.82824 8.76746L7.53045 6.46967C7.23755 6.17678 6.76268 6.17678 6.46979 6.46967C6.17689 6.76256 6.17689 7.23744 6.46979 7.53033L8.76758 9.82812Z"
                            fill="white"
                        />
                    </svg>
                </div>
                <div className="title">{t('title')}</div>
                <div className="desc">{t('desc')}</div>

                <EcoEmail
                    contactListId={[contactListIds[locale as keyof typeof contactListIds] ?? contactListIds.us]}
                    source="WEB_NEW_PRODUCT_SUB"
                    fields={fields}
                    termsHtml={termsHtml}
                    tipsObj={{
                        placeholder: t('placeholder'),
                        btnText: t('btnText'),
                    }}
                    needTerms
                />
            </div>
        </div>,
        document.body,
    );
};
export default Dialog;
